import styled from 'styled-components'

import { SelectorButton, fromMd } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding: ${o => o.theme.spacing(0, 4, 6, 4)};

  ${fromMd} {
    margin: 0 auto;
    padding: ${o => o.theme.spacing(0, 0, 6)};
  }
`

export const ToggleButton = styled(SelectorButton)`
  display: flex;
  align-items: center;
  justify-content: center;
`
